export const getParam = (key: string): string => {
  let queryarr = window.location.href
    .split("?")
    .filter(x => x.indexOf(key) >= 0);
  if (queryarr.length === 0) {
    return "";
  }
  let reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)", "i");
  let r = queryarr[0].match(reg);
  if (r != null) {
    return decodeURIComponent(r[2]);
  }
  return "";
};
